module.exports = __webpack_public_path__ + "static/media/Cersei Lannister 3.058cc58c.jpg";